export const UPDATE_AUM_TARGET = `
  mutation updateAumTarget($id:ID!, $roleId:ID!, $amount:Int!) {
    updateAumTarget(id: $id, roleId: $roleId, amount:$amount){
      aumTarget {
        id
        role {
            id
            name
        }
        amount
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_AUM_TARGET_SUMMARY = `
  query GetAumTarget($id:ID!) {
    aumTarget(id: $id ){
        id
        amount
        role {
            id
            name
        }
    }
  }
`;

export const DELETE_AUM_TARGET_MUTATION = `
  mutation DeleteAumTarget($id: ID!){
      deleteAumTarget(id: $id ){
        result
        errors{
          property
          description
        }
      }
  }
`;

export const GET_AUM_TARGETS = `
  query {
    aumTargets {
      id
      amount
      role {
        name
        users {
          id
        }
      }
    }
  }
`;

export const CREATE_AUM_TARGET = `
  mutation createAumTarget($roleId:ID!, $amount:Int!) {
    createAumTarget(roleId: $roleId, amount:$amount){
      aumTarget {
        id
        role {
            id
            name
        }
        amount
      }
      errors {
        property
        description
      }
    }
  }
`;